module.exports = __webpack_public_path__ + "fonts/Inter-400-cyrillic-ext43.857026d.woff2";